import React from "react";

export default function ML_Perceptrons() {
  return (
    <div>
      <h1>ML_Perceptrons</h1>
      <p>This is the ML_Perceptrons component.</p>
    </div>
  );
}
